import React, { useId } from 'react'

interface UseIconProps {
  className?: string
}

export const UseIcon: React.FC<UseIconProps> = ({ className }) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id}`
  const paint1Id = `paint1_linear_${id}`
  const paint2Id = `paint2_linear_${id}`

  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.62 5.40C12.83 4.17 11.99 2.86 11.45 1.34L12.45 0.83C12.93 2.19 13.65 3.30 14.41 4.49C14.69 4.92 14.96 5.35 15.24 5.80C16.26 7.49 17.16 9.41 17.16 12.05C17.16 14.73 16.10 16.54 15.03 18.14C14.90 18.33 14.78 18.50 14.66 18.68C13.70 20.10 12.82 21.39 12.48 23.17L11.42 22.87C11.83 20.78 12.88 19.25 13.82 17.85C13.94 17.68 14.06 17.50 14.18 17.33C15.23 15.76 16.08 14.26 16.08 12.05C16.08 9.81 15.33 8.17 14.36 6.56C14.13 6.18 13.88 5.79 13.62 5.40Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.52 9.16L12.90 4.11L13.53 5.03L6.15 10.08L5.52 9.16Z"
        fill={`url(#${paint0Id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.52 14.87L12.69 19.78L13.31 18.89L6.14 13.97L5.52 14.87Z"
        fill={`url(#${paint1Id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33 9.09H0L1.10 12.04L0 15.00H6.33L7.22 12.59H7.63L7.62 12.58H20.17C20.09 12.98 19.95 13.44 19.72 14.01L20.68 14.50C21.20 13.67 22.01 13.18 22.72 12.90C23.07 12.77 23.39 12.68 23.62 12.63C23.74 12.61 23.83 12.60 23.89 12.59C23.92 12.58 23.94 12.58 23.95 12.58C23.96 12.58 23.97 12.58 23.97 12.58L23.97 12.58L23.97 12.58L23.97 12.58L23.97 12.57L24.00 11.50C24.00 11.50 24.00 11.50 24.00 11.50L24.00 11.50L24.00 11.50L23.98 11.50C23.96 11.49 23.94 11.49 23.91 11.48C23.84 11.47 23.74 11.45 23.62 11.42C23.38 11.36 23.04 11.26 22.67 11.11C21.93 10.80 21.13 10.31 20.69 9.57L19.73 10.07C19.99 10.63 20.14 11.07 20.20 11.49H7.22L6.33 9.09ZM6.07 11.50L5.57 10.17H1.56L2.05 11.50H6.07Z"
        fill={`url(#${paint2Id})`}
      />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="9.53"
          y1="4.57"
          x2="9.53"
          y2="9.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="9.41"
          y1="19.33"
          x2="9.41"
          y2="14.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={paint2Id}
          x1="-1.79"
          y1="7.16"
          x2="26.45"
          y2="17.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
